import { render } from "./PayPerClick.vue?vue&type=template&id=30329487&scoped=true"
import script from "./PayPerClick.vue?vue&type=script&lang=js"
export * from "./PayPerClick.vue?vue&type=script&lang=js"

import "./PayPerClick.vue?vue&type=style&index=0&id=30329487&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30329487"]])

export default __exports__